import { BASE_STORE_INITIAL_STATE } from './chunk-7PCIVIEC.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/state/menu/initialStates/categories_initialState.ts
var CATEGORIES_INITIAL_STATE = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  name: "",
  organizationId: 0,
  createdByLocationId: 0,
  locationId: null,
  locationCategoryVersionId: 0,
  categoryId: 0,
  description: "",
  posName: "",
  backgroundColor: "",
  textColor: "",
  active: true,
  customizer: false,
  locationCategoryId: 0,
  menuTypeIds: [],
  itemIds: [],
  comboIds: [],
  subcategoryMenuTypeItemsIds: {},
  subcategoryMenuTypeCombosIds: {},
  otherSubcategoryId: null,
  subcategoryIds: [],
  sortPriority: 0,
  taxIds: []
});

export { CATEGORIES_INITIAL_STATE };
